import type { EntitlementFeature } from '@app/src/types/entitlements'
import { Typography } from '@mui/material'
import React from 'react'
import { policySummary } from './templatePolicy'
import { useEntitlementPolicies } from './useEntitlementPolicies'

type Props = {
  templateId: number
  features: EntitlementFeature[]
}

const TemplatePolicySummary: React.FC<Props> = ({ templateId, features }) => {
  const { policies, isLoading } = useEntitlementPolicies()

  if (isLoading) return null

  return (
    <Typography variant="caption" color="text.secondary" display="block" mt={1}>
      Default access policy: {policySummary(policies, features, templateId)}
    </Typography>
  )
}

export default TemplatePolicySummary
